/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { AnswerExtractionUsage } from './AnswerExtractionUsage.js';
import {
    AnswerExtractionUsageFromJSON,
    AnswerExtractionUsageFromJSONTyped,
    AnswerExtractionUsageToJSON,
} from './AnswerExtractionUsage.js';
import type { EmbeddingsUsage } from './EmbeddingsUsage.js';
import {
    EmbeddingsUsageFromJSON,
    EmbeddingsUsageFromJSONTyped,
    EmbeddingsUsageToJSON,
} from './EmbeddingsUsage.js';

/**
 * 
 * @export
 * @interface EvaluationUsage
 */
export interface EvaluationUsage {
    /**
     * 
     * @type {number}
     * @memberof EvaluationUsage
     */
    statementCollectionDurationMs?: number;
    /**
     * 
     * @type {number}
     * @memberof EvaluationUsage
     */
    statementResolutionDurationMs?: number;
    /**
     * 
     * @type {number}
     * @memberof EvaluationUsage
     */
    scriptEvaluationDurationMs?: number;
    /**
     * 
     * @type {Array<EmbeddingsUsage>}
     * @memberof EvaluationUsage
     */
    embeddings?: Array<EmbeddingsUsage>;
    /**
     * 
     * @type {Array<AnswerExtractionUsage>}
     * @memberof EvaluationUsage
     */
    answerExtraction?: Array<AnswerExtractionUsage>;
}

/**
 * Check if a given object implements the EvaluationUsage interface.
 */
export function instanceOfEvaluationUsage(value: object): boolean {
    return true;
}

export function EvaluationUsageFromJSON(json: any): EvaluationUsage {
    return EvaluationUsageFromJSONTyped(json, false);
}

export function EvaluationUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationUsage {
    if (json == null) {
        return json;
    }
    return {
        
        'statementCollectionDurationMs': json['statementCollectionDurationMs'] == null ? undefined : json['statementCollectionDurationMs'],
        'statementResolutionDurationMs': json['statementResolutionDurationMs'] == null ? undefined : json['statementResolutionDurationMs'],
        'scriptEvaluationDurationMs': json['scriptEvaluationDurationMs'] == null ? undefined : json['scriptEvaluationDurationMs'],
        'embeddings': json['embeddings'] == null ? undefined : ((json['embeddings'] as Array<any>).map(EmbeddingsUsageFromJSON)),
        'answerExtraction': json['answerExtraction'] == null ? undefined : ((json['answerExtraction'] as Array<any>).map(AnswerExtractionUsageFromJSON)),
    };
}

export function EvaluationUsageToJSON(value?: EvaluationUsage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statementCollectionDurationMs': value['statementCollectionDurationMs'],
        'statementResolutionDurationMs': value['statementResolutionDurationMs'],
        'scriptEvaluationDurationMs': value['scriptEvaluationDurationMs'],
        'embeddings': value['embeddings'] == null ? undefined : ((value['embeddings'] as Array<any>).map(EmbeddingsUsageToJSON)),
        'answerExtraction': value['answerExtraction'] == null ? undefined : ((value['answerExtraction'] as Array<any>).map(AnswerExtractionUsageToJSON)),
    };
}

